export const radiobutton = {
  root: {
    filledBackground: '{colors.white}',
    focusBorderColor: '{colors.gray}',
  },
};
